import { HasType } from "../agent.card";
import { SelectorFn } from "./selectorFn";

export type FallbackSelector<Selector> = {
    type: "fallback";
    options: Selector[];
    description?: string;
    unknownValue?: string;
};

export function fallbackSelector<Context, Selector extends HasType>(): SelectorFn<Context, FallbackSelector<Selector>> {
    return {
        isDefinedAt: () => true,
        execute: async ({ options, unknownValue }, context, messages, sc) => {
            const unknown = unknownValue ? unknownValue.toLowerCase() : "unknown";
            const fullLog: any[] = [];

            for (const selector of options) {
                const selFn = sc.selFns[selector.type];
                if (!selFn) return { errors: [`Selector function for type ${selector.type} not found`], log: { whatHappened: "fallbackSelector.missing", params: { selector } } };

                if (selFn.isDefinedAt && !selFn.isDefinedAt(selector, context, messages, sc)) {
                    fullLog.push({ type: selector.type, skipped: true });
                    continue;
                }

                const result = await selFn.execute(selector, context, messages, sc);
                fullLog.push({ type: selector.type, result: result.log });

                if ("errors" in result) return { ...result, log: { whatHappened: "fallbackSelector.error", params: fullLog } };

                if (result.value.selected && result.value.selected.toLowerCase() !== unknown) {
                    return { value: result.value, log: { whatHappened: "fallbackSelector.success", params: fullLog } };
                }

                // otherwise keep trying
            }

            // All returned 'unknown' — fallback case
            return {
                value: { context, selected: unknown, messages },
                log: { whatHappened: "fallbackSelector.allUnknown", params: fullLog },
            };
        },
    };
}
